<div class="body" [formGroup]="formGroup">

    <div class="input-wrapper wide block">

        <mat-form-field class="width" appearance="fill" style="margin-left: 2.4rem;">
            <mat-label>Titel</mat-label>
            <input formControlName="offertitle" matInput />
        </mat-form-field>

    </div>

    <div class="input-wrapper medium">
        <mat-icon class="icon">domain</mat-icon>
        <app-select-customer [appearance]="appearance" style="flex: 1" formControlName="offercustomer" label="Kunde">
        </app-select-customer>
    </div>

    <div class="input-wrapper medium">
        <mat-icon class="icon">location_on</mat-icon>
        <app-select-contact [appearance]="appearance" [customerSetted]="customerControl.value" style="flex: 1"
            formControlName="localcontact" label="Ansprechpartner vor Ort"></app-select-contact>
    </div>

    <div class="input-wrapper medium">
        <mat-icon class="icon">work_outline</mat-icon>
        <app-select-contact [appearance]="appearance" [customerSetted]="customerControl.value" style="flex: 1"
            formControlName="commercialcontact" label="Geschäftlicher Ansprechpartner"></app-select-contact>
    </div>

    <div class="input-wrapper medium">
        <mat-icon class="icon">rule</mat-icon>
        <app-select-status-form [appearance]="appearance" style="flex: 1" formControlName="offerstate"></app-select-status-form>
    </div>

    <div class="input-wrapper wide">

        <mat-icon class="icon">edit</mat-icon>

        <div class="block quill-wrapper quill-wrapper-white-toolbar quill-wrapper-graduated-bg">
            <quill-editor class="quill" theme="snow" format="html" formControlName="offerdesc" [modules]="modules"></quill-editor>
        </div>

    </div>

</div>